export const REQUIRED = 'Este campo es requerido';
export const TYPENUMBER = 'Tipo de dato inválido, ingrese un número por favor';
export const TYPE_NUMBER_INT = 'Tipo de dato inválido, ingrese un números enteros';
export const TYPE_NUMBER_POSITIVE = 'Tipo de dato inválido, solo número positivos';
export const TYPE_DATE = 'Tipo de dato inválido, ingrese una fecha por favor (dd-mm-yyyy)';
export const CORREO_TYPE = 'Tipo de dato inválido, ingrese un correo válido por favor';